module.exports = __webpack_public_path__ + "img/inbox-in.e70829ac.svg";